<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


import { autoSize } from "@/js/autosize";
export default {
  name: 'App',
  components: {

  }, watch: {
    '$route'(to) {
      document.title = `${to.meta.title}`;//第一种方法
    
    }
  },

  // 监听resize事件
  mounted() {
    autoSize();
    window.addEventListener("resize", () => {
      console.log(888)
      autoSize();
    });
  }
}
</script>

<style></style>
